import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

import Dropdown from "../../Components/Dropdown/DropdownMultiselect";
import FlipList from "../../Components/SlidingList/FlipList";
import SlidingListWrapper from "../../Components/SlidingList/SlidingListWrapper";

//const tasks = Array.from({ length: 17 }, (_, i) => `Task ${i + 1}`);

const tasks = [
  { title: "Daily Open Tasks", time: "4:00 am", count: "1 of 17" },
  { title: "Status Update", time: "7:00 am", count: "0 of 32" },
  { title: "Food Cost Report", time: "6:00 pm", count: "0 of 17" },
  { title: "AM Tasks", time: "10:00 pm", count: "0 of 24" },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(true);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Container fluid>
    <div className="container mt-4">
      {tasks.map((task, index) => (
        <FlipList key={task.title} index={index}>
          <div className="d-flex align-items-center gap-3">
            <div className="rounded-circle bg-primary text-white p-2">
              ICON
            </div>
            <div>
              <div>{task.title}</div>
              <small className="text-muted">{task.time}</small>
            </div>
          </div>
          <div className="text-muted">{task.count} ➜</div>
        </FlipList>
      ))}
    </div>
    </Container>
  );
}

export default App;
